'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = searchPerson;
/**
 * Search for persons in SP using clientPeoplePickerSearchUser.
 *
 * @param {string}	searchText part of name
 * @param {Object}	options
 * @param {number}  options.maximumEntitySuggestions default 10
 * @param {number}  options.principalType default 1
 * @param {number}  options.principalSource default 15
 * @param {string}  options.searchPrefix default ''
 * @param {string}  options.searchSuffix default ''
 *
 * @return {Promise<Object[]>} list of items with person data.
 */
function searchPerson(searchText, options) {
    var opts = Object.assign({
        maximumEntitySuggestions: 10,
        principalType: 1,
        principalSource: 15,
        searchPrefix: '',
        searchSuffix: ''
    }, options);

    return new Promise(function (resolve, reject) {
        window.SP.SOD.executeFunc("sp.js", "SP.ClientContext", function () {
            var spContext = window.SP.ClientContext.get_current();
            var queryTerm = '' + opts.searchPrefix + searchText + opts.searchSuffix;
            var query = new window.SP.UI.ApplicationPages.ClientPeoplePickerQueryParameters();
            query.set_allowMultipleEntities(false);
            query.set_maximumEntitySuggestions(opts.maximumEntitySuggestions);
            query.set_principalType(opts.principalType);
            query.set_principalSource(opts.principalSource);
            query.set_queryString(queryTerm);
            var searchResult = window.SP.UI.ApplicationPages.ClientPeoplePickerWebServiceInterface.clientPeoplePickerSearchUser(spContext, query);

            spContext.executeQueryAsync(function () {
                var res = spContext.parseObjectFromJsonString(searchResult.get_value());
                resolve(res);
            }, function (sender, args) {
                reject(sender, args);
            });
        });
    });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ntnu-react/util/sp/searchPerson.js
// module id = 1043
// module chunks = 0